var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-overlay"},[_c('div',{staticClass:"h-full",staticStyle:{"background-color":"#f0f2f5"}},[_vm._t("default"),_c('div',{staticClass:"copy-right"},[_c('copy-right-footer')],1)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }